import React, { Component } from "react";
import "./BannerArrow.scss";

class BannerArrow extends React.Component {
  handleClick = (options, e) => {
    if (e) {
      e.preventDefault();
    }
    this.props.setDirection(this.props.flowDirection, true);
    setTimeout(() => this.props.setDirection(""), 500);
    this.props.onClick(options, e);
  };

  render() {
    return (
      <div
        className={`${this.props.className} ${this.props.arrowDirection} top-sales-arrow-btn`}
        onClick={this.handleClick}
      />
    );
  }
}

export default BannerArrow;
